import {CobroOmni} from './CobroOmni';
export default CobroOmni;